const numberClose = (a, b) => {
  const left = Number(a);
  const right = Number(b);
  if (!Number.isFinite(left) && !Number.isFinite(right)) return true;
  if (!Number.isFinite(left) || !Number.isFinite(right)) return false;
  return Math.abs(left - right) <= 0.0000001;
};

const sameTime = (a, b) => Number(a?.time) === Number(b?.time);

const linePointEqual = (a, b) =>
  sameTime(a, b) && numberClose(a?.value, b?.value);

const candlePointEqual = (a, b) =>
  sameTime(a, b) &&
  numberClose(a?.open, b?.open) &&
  numberClose(a?.high, b?.high) &&
  numberClose(a?.low, b?.low) &&
  numberClose(a?.close, b?.close);

const pointEqualForKind = (kind) =>
  kind === "line" ? linePointEqual : candlePointEqual;

export const singlePointUpdateForDataChange = ({
  kind,
  previousData,
  nextData,
}) => {
  if (!Array.isArray(previousData) || !Array.isArray(nextData)) return null;
  if (previousData.length === 0 || nextData.length === 0) return null;
  if (nextData.length < previousData.length) return null;
  if (nextData.length > previousData.length + 1) return null;

  const pointsEqual = pointEqualForKind(kind);
  const unchangedPrefixLength =
    nextData.length === previousData.length
      ? previousData.length - 1
      : previousData.length;

  for (let idx = 0; idx < unchangedPrefixLength; idx += 1) {
    if (!pointsEqual(previousData[idx], nextData[idx])) {
      return null;
    }
  }

  const updatePoint = nextData[nextData.length - 1] || null;
  if (!updatePoint || !Number.isFinite(Number(updatePoint.time))) return null;
  return updatePoint;
};

export const applySeriesData = ({
  series,
  kind,
  previousData,
  nextData,
}) => {
  if (!series || !Array.isArray(nextData)) return "none";

  const updatePoint = singlePointUpdateForDataChange({
    kind,
    previousData,
    nextData,
  });

  if (updatePoint && typeof series.update === "function") {
    series.update(updatePoint);
    return "update";
  }

  if (typeof series.setData === "function") {
    series.setData(nextData);
    return "setData";
  }

  return "none";
};
